import React from 'react';
import ReactPlayer from 'react-player/file';
import { useTranslation } from 'react-i18next';
import styles from './Video.module.scss';

function NoVideo() {
  const { t } = useTranslation();

  return (
    <ReactPlayer
      error
      errorComponent={
        <div className={styles.videoError}>
          <div className={styles.wrapper}>
            <h3 className={styles.title}>{t('my_video.video_player.processing.title')}</h3>
            <p className={styles.caption}>{t('my_video.no_video.caption')}</p>
          </div>
        </div>
      }
    />
  );
}

export default NoVideo;
